import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Message, SpinnerService } from "shared-components";
import { ExpedicionesService } from "../../../services/expediciones.service";

@Component({
    selector: 'app-expediciones',
    templateUrl: './expediciones.component.html'
})
export class ExpedicionesComponent implements OnInit {
    @Input() confeccionId: number;

    public expediciones;
    private _filters;

    // Paginación
    public itemsPerPage = 10;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    // Ordenación
    public orderBy: string;
    public columnId: string;

    public showError = false;
    public mensajes = new Array<Message>();

    constructor(
        private _translate: TranslateService,
        private _spinnerService: SpinnerService,
        private _expedicionesService: ExpedicionesService
    ) {}

    ngOnInit(): void {
        this.getExpediciones();
    }

    private getExpediciones() {
        this._filters = {
            ...this._filters,
            consumoId: this.confeccionId,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };

        this._spinnerService.showSpinner();
        this._expedicionesService.getExpedicionesConfeccionesDetail(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.expediciones = resp.lista;
            this.totalItems = resp.paginacionMeta.totalCount;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public pageChange(page) {
        this._filters.numPagina = this.currentPage = page - 1;
        this.getExpediciones();
    }

    public itemsPerPageChange(items) {
        this._filters.numPagina = this.currentPage = 0;
        this._filters.tamPagina = this.itemsPerPage = items;
        this.getExpediciones();
    }

    public toOrderBy(columnFilter: string, colId: string) {
        this.columnId = colId;

        if (this.expediciones && this.expediciones.length > 0 && 
            this._filters) {
            const isAscending  = !this.orderBy || this.orderBy.includes('DESC');
            this.orderBy = isAscending ? 'ASC' + colId : 'DESC' + colId;
            this._filters.orderItems = [
                {
                    orderProperty: columnFilter,
                    orderByDescending: !isAscending
                }
            ];
            this.getExpediciones();
        }
    }

    public getIcon(colId: string) {
      let iconClass = 'fa fa-sort';

      if (this._filters?.orderItems && this.columnId === colId) {
          iconClass = this._filters.orderItems[0]?.orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public trackByCertificadoExpedicionId(index: number, expedicion: { certificadoExpedicionId: number }): number {
        return expedicion.certificadoExpedicionId;
    }
}
